/* tslint:disable */
/* eslint-disable */
export enum StructureInstallationType {
    VerySlow = 'VERY_SLOW',
    Slow = 'SLOW',
    Medium = 'MEDIUM',
    Fast = 'FAST',
    VeryFast = 'VERY_FAST'
}
